export default {"src":"/_next/static/media/arrow-header.e8bb5181.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};